export class Inputs extends EventTarget {
    constructor( map = [] ) {
        super();
        this.map = map;

        // create a map of inputs
        this.keys = {};
        this.map.forEach( input => {
            this.keys[input.name] = false;
        });
        // console.log( this.keys );

        addEventListener('keydown', (event) => {
            // console.log( event.code );
            this.down(event.code);
        });

        addEventListener('keyup', (event) => {
            // console.log( event.code );
            this.up(event.code);
        });
        console.log('Inputs initialized!');
    }

    down(key) {
        const map = this.map.find( input => input.keys.includes(key) );
        // console.log(map);
        if (map) {
           this.keys[map.name] = true;
        //    console.log(this.keys);
           this.dispatchEvent( new CustomEvent(map.name, { detail: { down: true} }));
        }
    }

    up(key) {
        const map = this.map.find( input => input.keys.includes(key) );
        if (map) {
            this.keys[map.name] = false;
            this.dispatchEvent( new CustomEvent(map.name, { detail: { down: false} }));
            // console.log(this.keys);
        }
    }
}
